import React, { Fragment, useState } from 'react';
import DialogBox from "qs-common/DialogBox";
import PersonalizedThemeData from "qs-data/personalizedTheme";
import "./style.scss";
import { trackAnalytics } from "../../../os";
import { deleteThemeFromCache } from '../../../pages/ThemesManager/reducer';
import { getI18N } from '../../../i18N';



export default function ({ showDialog, onClose, onSuccess, theme }) {
  const { t } = getI18N();
  const [progressBar, setProgressBar] = useState(false);
  const [closeDialog, setCloseDialog] = useState(false);

  const deleteTheme = async () => {
    setProgressBar(true);
    PersonalizedThemeData.deleteTheme(theme.id).then(() => {
      trackAnalytics({
        eventName: 'theme_deleted',
        props: {
          theme_id: theme.id
        }
      });
      setCloseDialog(true);
      onSuccess();
    }).catch((err) => {
      // Handle error
    }).then(() => {
      deleteThemeFromCache(theme.id)
      setProgressBar(false)
    });
  }

  return <DialogBox
    type={"simple"}
    dialogId={'#delete-theme'}
    show={showDialog}
    width={300}
    primaryBtnText={t('yes')}
    onSuccess={deleteTheme}
    onClose={onClose}
    showProgressBar={progressBar}
    closeDialog={closeDialog}
    danger
  >
    <Fragment>
      <div className='deleteTheme'>
        <p className='dialogTitle'>
          {t('are_you_sure_you_want_to_delete_theme', { theme: theme.name })}
        </p>
      </div>
    </Fragment>
  </DialogBox>
}
